import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const Airbnb = ({featuredProjectsList}) => {
  const project = getProject('airbnb');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          className="g-row"
          component={{
            posterVideo: '328625631'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            In 2018, Airbnb made a splash by announcing that they would expand
            their popular offering with Airbnb Plus.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20190405112237/Airbnb-cover.png',
            caption:
              "Airbnb Plus is a new tier of homes on Airbnb that have been verified for quality and comfort and was inspired by some of Airbnb's best hosts and homes."
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="preparing-for-launch">Preparing for launch</h2>
          <p>
            Leading up to the big reveal, Your Majesty got asked to define a
            creative direction and framework for the marketing content—including
            website, photography, and video direction.
          </p>
        </AnimateIn>

        <Image
          className="component--no-margin"
          component={{
            image:
              '//images.yourmajesty.co/20190405112245/Airbnb-device-intro.png'
          }}
        />

        <Image
          className="component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20190405112341/Airbnb-web.png'
          }}
        />

        <Image
          className=""
          component={{
            image: '//images.yourmajesty.co/20190405112315/Airbnb-phones2.png'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="an-intimate-and-agile-creative-workflow">
            An intimate and agile creative workflow
          </h2>
          <p>
            Our design team worked as an integrated unit, closely with Airbnb’s
            art department and product teams, to cycle through short sprints of
            rapid prototyping and concept iterations.
          </p>
        </AnimateIn>

        <Image
          className=""
          component={{
            image: '//images.yourmajesty.co/20190405112327/Airbnb-split-1.png',
            caption:
              'The team iterated through creation, validation, and revision until the direction fully encompassed the quality and comfort that Airbnb Plus represents.'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="getting-closer-to-the-hosts">Getting closer to the hosts</h2>
          <p>
            To convey the integrity and uniqueness of each Plus host, we created
            a template for a series of short interviews where each person
            explains why they love being a host and what makes their home
            unique.
          </p>
        </AnimateIn>

        <Image
          className=""
          component={{
            image:
              '//images.yourmajesty.co/20190405112254/Airbnb-filmgrid.png',
            caption:
              'By using a portrait video format, we set a more personal tone to each interview and created a closer connection between each host, and their guests.'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="guidelines-for-execution">Guidelines for execution</h2>
          <p>
            The delivery was a framework—containing guidelines for UX, creative,
            and content—that then led the internal teams to the final production
            of{' '}
            <a href="http://www.airbnb.com/plus" target="_blank" rel="noopener">
              Airbnb Plus
            </a>
            {' '}
            and its many touchpoints.
          </p>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2 id="about-airbnb-plus">About Airbnb Plus</h2>
          <p>
            Airbnb Plus is a new tier of homes on Airbnb that have been verified
            for quality and comfort and was inspired by some of Airbnb’s best
            hosts and homes.
          </p>
          <p>
            <a href="https://www.airbnb.com/plus" target="_blank" rel="noopener">
              Check out the site
            </a>
          </p>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2 id="like-what-you-see-">Like what you see?</h2>
          <p>
            Send us an email to{' '}
            <a href="mailto:hello@yourmajesty.co">
              hello@yourmajesty.co
            </a>{' '}
            to book a consultation on how we can take your digital touch-points
            to the next level.
          </p>
        </AnimateIn>

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Brand Strategy',
                  'Collaborative Working Sessions',
                  'Communications Strategy',
                  'Content Strategy',
                  'Creative Strategy',
                  'Prototyping & Validation',
                  'UX Strategy',
                  'Workshop & Facilitation'
                ]
              },

              {
                title: 'Design',
                items: [
                  'Art Direction',
                  'Creative Direction',
                  'Motion Design',
                  'Sound Design',
                  'UI/UX Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Content',
                items: [
                  'Animation',
                  'Live Action Direction',
                  'Live Action Production',
                  'Photography',
                  'Post Production'
                ]
              }
            ]
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default Airbnb;
